import React, { ReactElement } from 'react';
import { FormInstance } from 'antd/lib/form';

import { useClientFormContext } from '../ClientFormContext';
import ClientFormHeader from '../../../components/Client/ClientFormHeader';
import PriceMatrixFormSection from '../../../components/Feature/PriceMatrix/PriceMatrixFormSection';
import ClientForm from '../ClientForm';
import { submitPriceMatrixConfigFactory } from '../utils/submit';

const ClientPriceMatrixForm: React.FC = (): React.ReactElement => {
    const { client, data, formConfig, setData } = useClientFormContext();

    const submitForm = async (form: FormInstance): Promise<void> => {
        if (!client) return;

        const priceMatrix = await submitPriceMatrixConfigFactory(client.id, data.priceMatrix)(form);
        setData({ ...data, priceMatrix });
    };

    return (
        <>
            <div className="shadow-sm pb-4">
                <ClientFormHeader />
                <div className="px-4">
                    <ClientForm name="price-matrix" submitForm={submitForm}>
                        {({ form }): ReactElement => (
                            <PriceMatrixFormSection
                                formInstance={form}
                                isDetailMode={formConfig.isDetailMode}
                                priceMatrixConfig={data.priceMatrix}
                            />
                        )}
                    </ClientForm>
                </div>
            </div>
        </>
    );
};

export default ClientPriceMatrixForm;
